module.exports = __webpack_public_path__ + "img/p65.b84f1c74.png";